<div class="lv-info-text-tooltip-collapsable" *ngIf="showInfotext" [innerHTML]="tooltip | translate"
     [@inOut]></div>
